(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-embroidery"]) return;
  try {
    
  function initializeProductOfferCards(container) {
    var scope = container || document;

    scope.querySelectorAll('.wm-product-offer-card').forEach(function (card) {
      if (card.dataset.offerCardInitialized === 'true') return;

      var tabs = card.querySelectorAll('[data-offer-tab]');
      var panels = card.querySelectorAll('[data-offer-panel]');
      var toggle = card.querySelector('[data-offer-toggle]');
      var content = card.querySelector('[data-offer-content]');

      if (!toggle || !content || tabs.length === 0 || panels.length === 0) return;

      function setExpanded(expanded) {
        card.classList.toggle('is-open', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (expanded) {
          content.removeAttribute('hidden');
        } else {
          content.setAttribute('hidden', '');
        }
      }

      function activateTab(targetId) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-offer-tab') === targetId;
          tab.classList.toggle('is-active', isActive);
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        if (content.hasAttribute('hidden')) {
          setExpanded(true);
        }
      }

      toggle.addEventListener('click', function () {
        setExpanded(content.hasAttribute('hidden'));
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('data-offer-tab'));
        });
      });

      setExpanded(false);
      card.dataset.offerCardInitialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeProductOfferCards(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeProductOfferCards(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initializeProductOfferCards(container) {
    var scope = container || document;

    scope.querySelectorAll('.wm-product-offer-card').forEach(function (card) {
      if (card.dataset.offerCardInitialized === 'true') return;

      var tabs = card.querySelectorAll('[data-offer-tab]');
      var panels = card.querySelectorAll('[data-offer-panel]');
      var toggle = card.querySelector('[data-offer-toggle]');
      var content = card.querySelector('[data-offer-content]');

      if (!toggle || !content || tabs.length === 0 || panels.length === 0) return;

      function setExpanded(expanded) {
        card.classList.toggle('is-open', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (expanded) {
          content.removeAttribute('hidden');
        } else {
          content.setAttribute('hidden', '');
        }
      }

      function activateTab(targetId) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-offer-tab') === targetId;
          tab.classList.toggle('is-active', isActive);
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        if (content.hasAttribute('hidden')) {
          setExpanded(true);
        }
      }

      toggle.addEventListener('click', function () {
        setExpanded(content.hasAttribute('hidden'));
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('data-offer-tab'));
        });
      });

      setExpanded(false);
      card.dataset.offerCardInitialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeProductOfferCards(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeProductOfferCards(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
